export enum FetchingStatusEnum {
  Pending = 'pending',
  Success = 'success',
  Error = 'error',
  Init = 'init',
}
